var card_content_default = {
  "content": "UWdvJ",
  "textStart": "Q2pec",
  "contentText": "_6q5AC",
  "subtitle": "reQbV",
  "pricing": "Bjodw",
  "titlePriceContainer": "WNoOg",
  "textCenter": "Jed41",
  "textEnd": "Ke7x8",
  "titlePriceSideBySide": "G36-r",
  "titlePriceStacked": "xnQK1",
  "title": "QwvfB",
  "price": "TVFyR",
  "priceDiscounted": "n-Bjt",
  "priceOriginal": "OUZNH",
  "priceStrikethrough": "XLP7Z",
  "ribbon": "ViN-l",
  "button": "utoUO",
  "button_disabled": "BvjRO",
  "buttonText": "FiDp-",
  "framelessContent": "PaVX-",
  "framelessImageTop": "m5JN8",
  "framelessImageStart": "DG6R-",
  "framelessImageEnd": "GvcXM"
};
export {
  card_content_default as default
};
//# sourceMappingURL=card-content-scss.js.map
